import React, { ReactNode } from 'react';

import classNames from 'classnames';

import classes from './WidgetTitle.module.scss';
import {
  IconBackgroundWrapper,
  InfoTooltip,
} from '../../../shared/components/ui-components';

type WidgetTitleProps = {
  title: string;
  icon: ReactNode;
  endAdornment?: ReactNode;
  tooltipContent?: ReactNode;
  className?: string;
};

const WidgetTitle = ({
  title,
  icon,
  endAdornment,
  tooltipContent,
  className,
}: WidgetTitleProps) => {
  const containerClasses = classNames(classes.container, className);
  return (
    <div className={containerClasses}>
      <div className={classes.titleBlock}>
        {icon && <IconBackgroundWrapper icon={icon} className={classes.icon} />}
        <h3>{title}</h3>
        {tooltipContent && (
          <InfoTooltip arrow placement="right">
            {tooltipContent}
          </InfoTooltip>
        )}
      </div>
      {endAdornment}
    </div>
  );
};

export { WidgetTitle };
